<template>
  <v-row no-gutters class="pl-2" align="center">
    <v-col cols="3">
      <v-list-item>
        <v-list-item-avatar>
          <v-img :src="avatar_img"></v-img>
        </v-list-item-avatar>
        <v-list-item-content class="">
          <v-list-item-title>
            {{ specie.nome }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ specie.nome_sc }}
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-col>
    <v-col cols="1">
      <v-icon :color="specie.exposition == 1 ? 'indigo' : 'grey lighten-2'"
        >mdi-weather-cloudy</v-icon
      >
      <v-icon :color="specie.exposition == 2 ? 'blue' : 'grey lighten-2'"
        >mdi-weather-partly-cloudy</v-icon
      >
      <v-icon :color="specie.exposition == 3 ? 'orange' : 'grey lighten-2'"
        >mdi-weather-sunny</v-icon
      >
    </v-col>
    <v-col cols="1">
      <v-icon :color="specie.manutenzione > 0 ? 'red' : 'grey lighten-2'">{{
        specie.manutenzione > 0 ? "mdi-heart" : "mdi-heart-outline"
      }}</v-icon>
      <v-icon :color="specie.manutenzione > 1 ? 'red' : 'grey lighten-2'">{{
        specie.manutenzione > 1 ? "mdi-heart" : "mdi-heart-outline"
      }}</v-icon>
      <v-icon :color="specie.manutenzione > 2 ? 'red' : 'grey lighten-2'">{{
        specie.manutenzione > 2 ? "mdi-heart" : "mdi-heart-outline"
      }}</v-icon>
    </v-col>
    <v-col cols="1">
      <v-icon :color="specie.water_request > 0 ? 'blue' : 'grey lighten-2'">{{
        specie.water_request > 0 ? "mdi-water" : "mdi-water-outline"
      }}</v-icon>
      <v-icon :color="specie.water_request > 1 ? 'blue' : 'grey lighten-2'">{{
        specie.water_request > 1 ? "mdi-water" : "mdi-water-outline"
      }}</v-icon>
      <v-icon :color="specie.water_request > 2 ? 'blue' : 'grey lighten-2'">{{
        specie.water_request > 2 ? "mdi-water" : "mdi-water-outline"
      }}</v-icon>
    </v-col>
    <v-col cols="1">
      <v-icon :color="specie.frost_resist ? 'blue' : 'grey lighten-2'">{{
        specie.frost_resist ? "mdi-snowflake" : "mdi-snowflake-off"
      }}</v-icon>
    </v-col>
    <v-col cols="1">
      <v-icon v-if="specie.propagazione" :color="specie.propagazione == 1 ? 'brown lighten-2' : 'green'">{{
        specie.propagazione == 1 ? "mdi-seed" : "mdi-leaf"
      }}</v-icon>
    </v-col>
    <v-col cols="1">
      <span v-if="specie.tempo_vendita != null" class="text-caption grey--text">
        <v-icon small color="grey">mdi-calendar-clock</v-icon>
        {{ specie.tempo_vendita }} sett.
      </span>
    </v-col>
    <v-col cols="1"></v-col>
    <v-col cols="2">
      <v-btn icon color="green" @click="$refs.info_dialog.open()">
        <v-icon color="blue accent-2">mdi-information-outline</v-icon>
      </v-btn>
      <InfoSpecie :id_specie="specie.id" ref="info_dialog"/>
      <v-btn icon color="green" @click="$refs.scheda_varieta.open()">
        <v-icon color="green darken-5">mdi-sprout</v-icon>
      </v-btn>
      <!-- <SchedaColori :specie="specie" ref="scheda_colori"></SchedaColori> -->
      <SchedaVarieta :specie="specie" ref="scheda_varieta"></SchedaVarieta>
      <EditSpecie :specie="specie" />
      <v-dialog v-model="dialog_elimina" width="400">
        <template v-slot:activator="{ on }">
          <v-btn icon color="red" v-on="on" class="ml-4"
            ><v-icon class="">mdi-delete</v-icon></v-btn
          >
        </template>
        <v-card>
          <v-card-title>Elimina Specie</v-card-title>
          <v-card-text> Sei Sicuro? </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text color="grey" @click="dialog_elimina = false"
              >Annulla</v-btn
            >
            <v-btn
              outlined
              color="red"
              @click="elimina_specie()"
              :loading="loading_elimina"
              ><v-icon class="mr-2">mdi-delete</v-icon>Elimina</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import EditSpecie from "./specie_dialog.vue";
// import SchedaColori from "./colori/scheda_colori.vue";
import SchedaVarieta from "./varieta/scheda_varieta.vue";
import InfoSpecie from "./info/informazioni_specie.vue"
export default {
  components: {
    EditSpecie,
    InfoSpecie,
    SchedaVarieta,
  },
  props: {
    specie: Object,
  },
  data() {
    return {
      dialog_elimina: false,
      loading_elimina: false,
    };
  },
  computed: {
    avatar_img() {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        this.specie.id +
        "/img?md5=" +
        this.specie.img_md5
      );
    },
  },
  methods: {
    elimina_specie() {
      this.loading_elimina = true;
      this.$store
        .dispatch("elimina_specie", { id_specie: this.specie.id })
        .catch((err) => {
          alert(err);
        })
        .finally(() => {
          this.loading_elimina = false;
        });
    },
  },
};
</script>